import { render, staticRenderFns } from "./app-aside.vue?vue&type=template&id=a3f15ac6&scoped=true&"
import script from "./app-aside.vue?vue&type=script&lang=js&"
export * from "./app-aside.vue?vue&type=script&lang=js&"
import style0 from "./app-aside.vue?vue&type=style&index=0&id=a3f15ac6&lang=scss&scoped=true&"
import style1 from "./app-aside.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f15ac6",
  null
  
)

export default component.exports